import { createApp } from 'vue';
import TiffToJpgConverter from '@/Components/TiffToJpgConverter.vue';
import '@styles/app.css';

createApp(TiffToJpgConverter).mount('#tiff-to-jpg-converter');
